import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Camera } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import ReportNewsForm from "@/components/ReportNewsForm";
import ShareReportLink, { REPORT_PATH } from "@/components/ShareReportLink";

export default function ReportNewsButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const { pathname } = useLocation();

  const open = () => {
    setFormKey((k) => k + 1);
    setIsOpen(true);
  };

  // Ya estamos en la página dedicada del formulario
  if (pathname === REPORT_PATH || pathname === "/reportar-noticia") return null;

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={open}
        className="fixed bottom-6 right-6 z-50 bg-red-600 hover:bg-red-700 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 group"
        data-testid="report-news-button"
        aria-label="Reporta una noticia"
      >
        <div className="flex items-center gap-2">
          <Camera className="h-6 w-6" />
          <span className="hidden group-hover:inline text-sm font-medium pr-1">
            Reporta una noticia
          </span>
        </div>
      </button>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <Camera className="h-5 w-5" />
              Reporta una Noticia
            </DialogTitle>
          </DialogHeader>

          <ShareReportLink className="mb-2" />

          <ReportNewsForm
            key={formKey}
            autoResetAfterSuccess
            onSuccess={() => setTimeout(() => setIsOpen(false), 2200)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
